import { parseHydrationErrorInfo } from './hydrationLog';

/**
 * Dispatches a custom hydration error event
 * @param {Error} error - The hydration error
 * @param {Object} errorInfo - Additional error information from React
 */
export function dispatchHydrationError(error, errorInfo) {
	if (typeof window !== 'undefined' && window.dispatchEvent) {
		window.dispatchEvent(
			new CustomEvent('hydrationError', {
				detail: {
					error: error.message,
					stack: parseHydrationErrorInfo(errorInfo),
					timestamp: Date.now(),
				},
			}),
		);
	}
}
